import { IThunkActionCreator } from '../../index';
import { getItemBasedSimilarOffers } from '../../../api/similar';
import { similarOffersReceived } from './similarOffersReceived';

export function requestItemBasedSimilarOffers(offerId: number, publishedUserId: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getItemBasedSimilarOffers(context.httpApi, { cianOfferId: offerId, publishedUserId }).then(res => {
      if (res.statusCode === 200) {
        dispatch(similarOffersReceived(res.response, 'itemBased'));
      }
    });
  };
}
